<template>
<div class="headerbox">
	<div class="header">
	  <div class="f-row-c" :class="classv?'headcon':'headcon_o'">
	    <div class="l_c">
	      <el-image fit='contain' class="imgcon" :src="require('../assets/newimg/topimg@2x.png')" alt="" @click="toindex"></el-image>
	    </div>
	
	    <div class="r_c">
	      <div
	        :class="tabindex == index ? 'pro_cur' : 'pro'"
	        v-for="(item, index) in tablist"
	        :key="index"
	        @click="selectTab(item.pathurl, index)"
	      >
	        <!-- <div></div> -->
			{{ item.name }}
	      </div>
	    </div>
	  </div>
	</div>
	
</div>	
  
  
  
</template>

<script>
export default {
  props: ["tabsign","ifclass"],
  data: function () {
    return {
	  classv:true,	
      tabindex: 0,
      tablist: [
			{ name: "首页", pathurl: "/" },
			{ name: "公益项目", pathurl: "/publicwelpro" },
			{ name: "申请帮扶", pathurl: "/applyforhelp" },
			{ name: "爱心榜", pathurl: "/lovelist" },
			{ name: "新闻中心", pathurl: "/newscenter" },
			{ name: "公示公告", pathurl: "/publicannounce" },
			{ name: "信息公开", pathurl: "/informdisclosure" },
			{ name: "政策法规", pathurl: "/policiesandregulations" },
			{ name: "公益活动", pathurl: "/publicbenact" },
			{ name: "关于我们", pathurl: "/aboutus" },
      ],
    };
  },
  
  mounted() {
  		this.tabindex = this.tabsign;
		this.classv = this.ifclass;		
  },
  
  watch: {
		ifclass: function(newVal, oldVal) { 
			this.classv = newVal;	   
		}
  },	
  
  methods: {
		selectTab(e, index) {
			  // this.tabindex = index
			  if (this.$route.path == e) {
				 this.$router.go(0);
			  } else {
				 this.$router.push({ path: e, query: {} });
			  }
		},
		
		toindex(){
			if (this.$route.path == '/') {
				this.$router.go(0);
			} else {
				this.$router.push({ path: '/', query: {} });
			}				
		}
		
  },
  
  

};
</script>

<style scoped="scoped" lang="scss">
.headerbox{

}
.header {
  overflow:hidden;
  position: fixed;
  top: 0px;
  z-index: 30;
  width: 100%;
//   min-width: 1200px;
  .headcon {
    width: 100%;
    height: 100px;
    background: rgba(255, 255, 255, 0.73);
  }	
  .headcon_o {
    width: 100%;
    height: 100px;
  	background: #FFFFFF;
	border-bottom:2px solid #E50112;
  }	
  .l_c {
	  text-align: right;
	  padding-right: 40px;
	  .imgcon {
		cursor: pointer;
		max-width: 400px;
		width: 100%;
		height: 70px;
	  }
  }
  .r_c {
      display: flex;
	//   min-width: 1200px;
	  min-width: calc(100% - 440px);
	  .pro_cur,.pro {
			text-align: center;
			flex-grow: 1;
			height: 100px;
			line-height: 100px;
			color: #333333;
			font-size: 18px;
			cursor: pointer;
			white-space:nowrap;
			box-sizing: border-box;
      }
      .pro_cur{
			background: #e50112;
			color: #ffffff;
      }
     
   }
}
.f-row-c{
	display: flex;
	align-items: center;
	justify-content: center;
}
.f-row-l{ 
	display: flex;
	align-items: center;
	align-content: center;
	justify-content: flex-start;
}
.f-row-b{
	display: flex;
	align-items: center;
	align-content: center;
	justify-content: space-between;
}
.f-row-start-b{
	display: flex;
	align-items: flex-start;
	align-content: flex-start;
	justify-content: space-between;
}
@media only screen and (max-width: 1170px){
	.header .l_c{
	    display: none;
	 }
	 .header .r_c{
		 min-width: 100%;
	 }
} 
// @media screen and (max-width: 750px) {
// 	.header .l_c{
// 	    display: block;
// 	 }
// 	 .header .r_c{
// 		 min-width: calc(100% - 440px);
// 	 }
// }
</style>
